  import JobDemo3Container from "../../components/home/jobDemo3";

const JobDemo3 = () => {
  return <JobDemo3Container />;
};

export default JobDemo3;
